<div class="wrapper">
  <input type="checkbox" [(ngModel)]="checked" />
  <label class="toggle" (click)="toggleChecked()"></label>
  <div class="label">{{ label }}</div>
</div>
